// extracted by mini-css-extract-plugin
export var base = "_3h-0";
export var updateBanner = "_3h-1";